import { BaseService } from "services/_baseService";
import appAxios from "services/axios";

class ProductsAdminService extends BaseService<any> {
  constructor() {
    super(`products`);
  }
  uploadImages = async (id: number, formData: FormData) => {
    return appAxios.post(`${this.pathWithOrg()}/${id}/media`, formData);
  };
}

export default new ProductsAdminService();
